import gql from 'graphql-tag'

export const GetGenreQuery = gql`
  query getGenre {
    genre {
      id
      title
      createdAt
    }
  }
`